import { render, staticRenderFns } from "./MyCropfiveyearstrade.vue?vue&type=template&id=68b198e4&scoped=true&"
import script from "./MyCropfiveyearstrade.vue?vue&type=script&lang=js&"
export * from "./MyCropfiveyearstrade.vue?vue&type=script&lang=js&"
import style0 from "./MyCropfiveyearstrade.vue?vue&type=style&index=0&id=68b198e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b198e4",
  null
  
)

export default component.exports